import { useCallCenterRouteOrders } from "api/call-center/routes/hooks";
import { HighlightedRow } from "api/other/models";
import { UUID } from "api/types";
import { InvoicePagination } from "components/common/invoicePagination/InvoicePagination";
import { CommonError, RightPanelHandler } from "components/utils";
import { RightPanel } from "./rightPanel/RightPanel";
import { ListDrawerWrapper } from "components/utils/drawer";
import { Loader } from "components/utils/loader";
import { ModuleList } from "components/utils/moduleList";
import { ModuleListBody } from "components/utils/moduleList/components/ModuleListBody";
import { ModuleListHeader } from "components/utils/moduleList/components/ModuleListHeader";
import { callCenterOrdersListConfig } from "components/utils/moduleList/utils/moduleListConfig";
import { NoResults } from "components/utils/noResults";
import { useQuery } from "hooks";
import { useState } from "react";
import { handleMultipleRowsHighlight } from "utilities/handleMultipleRowsHighlight";
import { CallInProgressPopUp } from "../routeOrdersList/components/CallInProgressPopUp";
import { ListHeader } from "./components/ListHeader";
import { ListItem } from "./components/ListItem";
import { getSearch } from "./utils/getSearch";

export const OrdersList = () => {
  const { query } = useQuery({ exclude: ["panelId"] });
  const search = getSearch({ query, ordering: encodeURIComponent("-created") });
  const { data: orders, error, isLoading, pagination } = useCallCenterRouteOrders(search);

  const [highlightedRows, setHighlightedRows] = useState<HighlightedRow[]>([]);
  const [callInProgress, setCallInProgress] = useState<number | null>(null);

  const noResults = !orders.length && !isLoading && !error;

  if (error) {
    return (
      <div>
        <ListHeader />
        <div className="mt-4">
          <CommonError status={error._httpStatus_} />
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div>
        <Loader module="callCenter" />
        <ListHeader />
      </div>
    );
  }

  const selectMutlipleItems = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: UUID | number,
    index: number,
    togglePanel: () => void,
  ) => {
    handleMultipleRowsHighlight(
      event,
      highlightedRows,
      id,
      index,
      setHighlightedRows,
      togglePanel,
      orders,
    );
  };

  return (
    <div className="pageContainer">
      <ListHeader />
      <RightPanelHandler name="callCenterOrders">
        {({ close, isActive, isHighlighted, togglePanel }) => (
          <ListDrawerWrapper>
            {noResults ? (
              <NoResults on={noResults} subHeader="zamówienia" />
            ) : (
              <ModuleList>
                <ModuleListHeader
                  gridStyle={callCenterOrdersListConfig.grid}
                  labels={callCenterOrdersListConfig.labels}
                />
                <ModuleListBody>
                  {orders.map((order, index) => (
                    <ListItem
                      highlightedRows={highlightedRows}
                      index={index}
                      isActive={isActive}
                      isHighlighted={isHighlighted}
                      key={order.id}
                      order={order}
                      selectMutlipleItems={selectMutlipleItems}
                      callInProgress={callInProgress}
                      setCallInProgress={setCallInProgress}
                      togglePanel={togglePanel}
                      search={search}
                    />
                  ))}
                </ModuleListBody>
              </ModuleList>
            )}
            <RightPanel close={close} />
            <InvoicePagination pagination={pagination} />
          </ListDrawerWrapper>
        )}
      </RightPanelHandler>
      {callInProgress && (
        <CallInProgressPopUp
          callInProgressId={callInProgress}
          setCallInProgress={setCallInProgress}
        />
      )}
    </div>
  );
};
